import { useProfile } from 'core-lib/hooks/useProfile';
import { AddToCartType } from 'src/modules/parkplusStoreV2/types/cart';
import { PdpPropType } from 'src/modules/parkplusStoreV2/types/product';
import AddToCart from 'src/modules/parkplusStoreV2/uiComponents/AddToCart';
import MoreProductDetails from 'src/modules/parkplusStoreV2/uiComponents/PdpComponents/MoreProductDetails';
import Carousel from './Carousel';
import CheckDelivery from './CheckDelivery';
import CoreDetails from './CoreDetails';
import Offers from './Offers';
import s from './StorePdp.module.scss';
import Reviews from './Reviews';
import Variants from './Variants';
import dynamic from 'next/dynamic';
import GenericInfo from './GenericInfo';
import { Divider } from 'ui-v2/components/Divider';
import StoreAppBar from 'src/modules/parkplusStoreV2/uiComponents/StoreAppBar';
import { useRef } from 'react';
const Layouts = dynamic(
  () => import('src/modules/parkplusStoreV2/uiComponents/Layouts'),
  {
    ssr: false,
  }
);
const GiftOnly = dynamic(() => import('./GiftOnly'));

export const StorePdp = ({ data, updatePdpSlice }: PdpPropType) => {
  // custom hooks
  const { isAuthenticated } = useProfile();
  const reviewsRef = useRef<HTMLDivElement>(null);

  const scrollToReviews = () => {
    reviewsRef.current?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <div className={s.root}>
      <StoreAppBar
        showCart
        showFuel
        showShare
        title=""
        renderAppBarOnly
        bgColor='primary'
        isSticky
      />
      <Carousel data={data} onReviewClick={scrollToReviews} />
      <CoreDetails data={data} />
      <Variants pdpdata={data} updatePdpSlice={updatePdpSlice} />
      {data?.isGift && <GiftOnly />}
      {isAuthenticated && (
        <CheckDelivery pickUpPostCode={data?.pickUpPostCode} />
      )}
      {data?.genericInfo?.length >= 0 && <GenericInfo data={data.genericInfo} />}
      <Offers data={data} />
      <MoreProductDetails data={data} />
      {!!data && <div ref={reviewsRef}>
        <Reviews data={data} />
      </div>}

      {data?.similarProducts?.length > 0 && (
        <>
          <Divider variant="padded" />
          <Layouts data={data?.similarProducts} />
        </>
      )}
      {!data?.isGift && (
        <AddToCart product={data} type={AddToCartType.ProductDescription} />
      )}
    </div>
  );
};
